(function () {
	angular
		.module('trackeye')
		.factory('PositionsService', PositionsService);

	PositionsService.$inject = ['OpenLayersService', '$rootScope'];

	function PositionsService(OpenLayersService, $rootScope) {
		var exports = {};

		/**
		 * @type {object}
		 * @property {Device|undefined} device - selected device
		 * @property {SutMessage|undefined} message - selected message
		 * @property {boolean} searched - Position list is serached
		 * @property {boolean} fleet - Showing fleet
		 */
		var data = {
			device: undefined,
			message: undefined,
			searched: false,
			fleet: false
		};

		/**
		 * @param {SutMessage} message
		 */
		exports.setMessage = function (message) {
			_message(message);
			_moveFeature();
		};

		/**
		 * Getter/setter of searched state
		 * @param {boolean} [value]
		 * @returns {boolean}
		 */
		exports.searched = function (value) {
			if (!angular.isDefined(value))
				return data.searched;

			return data.searched = value;
		};

		/**
		 * Getter/setter of fleet state
		 * @param {boolean} [value]
		 * @returns {boolean}
		 */
		exports.fleet = function (value) {
			if (!angular.isDefined(value))
				return data.fleet;

			return data.fleet = value;
		};

		/**
		 * Getter/setter for selected sutmessage
		 * @param {SutMessage} [message]
		 * @returns {SutMessage}
		 */
		function _message(message) {
			if (!message)
				return data.message;

			return data.message = message;
		}

		/**
		 * Getter/setter for selected device
		 * @param {Device} [device]
		 * @returns {Device}
		 */
		function _device(device) {
			if (!device)
				return data.device;

			return data.device = device;
		}

		function _moveFeature () {
			var device = _device(),
				message = _message();

			if (!OpenLayersService.hasCoord())
				OpenLayersService.setInitialZoom();

			OpenLayersService
				.moveFeatures(device.getUuid(), message)
				.setCenter(message);

			// If the message is a GSM, zoom the map to fit the circle.
			if (message.isGSM())
				OpenLayersService.setFocus();
		}

		function _updateMap(fleet) {
			var device = _device(),
				message = _message();


			if (!fleet) {
				if (!message.hasLonLat()) {
					OpenLayersService
						.hideAllFeatures(4)
						.setCurrentCoord(undefined);
				} else {
					if (!OpenLayersService.hasCoord()) {
						OpenLayersService.setInitialZoom();
					}
					OpenLayersService
						.moveFeatures(
							device.getUuid(),
							message
						)
						.setFocus();
				}
			} else {
				var names = fleet.map(function(fleet_device) {
					fleet_device.latest.fetchAddress();
					return fleet_device.latest.hasLonLat() ? fleet_device.getUuid() : null
				}).filter(function(name) {
					return !!name;
				});
				OpenLayersService
					.showFeatures(names)
					.hideCircles()
					.setFocus('markerLayer');
			}
		}

		/**
		 * @param {Object} e
		 * @param {Device} device
		 */
		function onDeviceSelected (e, device) {
			exports.searched(false);

			if (_device())
				OpenLayersService.hideFeatures([_device().getUuid()]);

			_message(device.latest);
			_device(device);
			_updateMap();
		}

		/**
		 * @param {Object} e
		 * @param {Device} device
		 */
		function onDeviceData (e) {
			var device = _device(),
				message = _message();

			if (exports.fleet()) {
				var fleet = exports.fleet(),
					devices = fleet.filter(function(fleet_device) {
						return fleet_device.latest.hasLonLat()
					})

				devices.forEach(function(fleet_device) {
					if (fleet_device === device) {
						_message(fleet_device.latest);
					}
				})

				_updateMap(devices);
			} else {
				if (
					message.getId() &&
					device.getNodeId() === message.getNodeId() &&
					device.latest.hasLonLat() &&
					!exports.searched()
				) {
					device.latest.fetchAddress();
					_message(device.latest);
					_updateMap();
				}
			}
		}

		$rootScope.$on('DeviceService.selected', onDeviceSelected);
		$rootScope.$on('DeviceService.data', onDeviceData);

		return exports;
	}
})();